import { type EntryId, type FieldId } from '../../../machine/state/types';

export function getCellElementByIds({
  entryId,
  fieldId,
}: {
  entryId: EntryId;
  fieldId: FieldId;
}): HTMLTableCellElement | null {
  return document.querySelector(
    `[data-entry-id="${entryId}"][data-field-id="${fieldId}"]`
  );
}
